import { Typography } from "@mui/material"
import type { FC } from "react"

interface FormSectionLabelProps {
  label: string
}

export const FormSectionLabel: FC<FormSectionLabelProps> = ({ label }) => (
  <Typography className='text-sm font-medium text-gray-800'>{label}</Typography>
)
